import * as React from 'react';
import { useEffect, useState } from 'react';
import BomTabsData from './BomTabsData/BomTabsData';
import { useSearchParams } from "react-router-dom";
import Common from "../Common";
import Bom from "@system/config/bom";
import { useBOMStore } from "../../../hooks/bom";
import { useSelector } from 'react-redux';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import { isObject } from "underscore";
import { useCartStore } from 'src/hooks/cart';
import System from "../../../helper/system";
import useReduxState from "../../../hooks/useReduxState";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import BOMRepository from 'src/repository/BOMRepository';
import { SET_bomMultipleMatchTrigger } from 'src/store/slice/model/BOM';
import BomExactMatchValidation from './BomTabsData/BomExactMatchValidation';
import produceClone from 'src/helper/produceClone';
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import { __set, __remove } from 'src/store/axios_indicator';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import Constants from 'src/support/Constants';
import liveAuth from 'src/helper/liveAuth';
import Helper from 'src/support/Helper';
import BomfarnellList from './BomFarnellList';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { useBOMProjectStore } from 'src/hooks/bom_project';

const bom_id = System.getParams().bomId;
const BomTabs = () => {
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const [{ bom_detail_by_bom_id_type, bomMultipleMatchTrigger, bom_detail_by_bom_id }, { get_bom_detail_by_bom_id_with_type, get_bom_detail_count_by_bom_id }] = useBOMStore();
    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [{ CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER, CART_BEFORE_TO_SEND_SERVER }, { check_item_exists_in_cart, initiatedKernelCall }, { add_cart_in_Bulk }] = useCartStore();
    const [validCartCount, setValidCartCount] = useState(0)
    const [validQuoteCount, setValidQuoteCount] = useState(0)
    const [, setInitialLoader] = useState(true)
    const [, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [{ bomPricingList }, { }, { }] = useProductPricingStore();
    const [, { get_inventory_by_id  }, { }] = useProductInventoryStore();
    const [, setCheckoutFarnellClick] = useReduxState(false, 'setCheckoutFarnellClick')
    const [headerDistance, setHeaderDistance] = useState(0);
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    const [BomTabList__Component__Loader, Set_BomTabList__Component__Loader] = useReduxState(searchParams.get(Common.param_key_BomTabList) ? searchParams.get(Common.param_key_BomTabList) : Common.default_component_BomTabList.param_value, Common.redux_key_BomTabList, 'BomTabList__Component__Loader');
    let selected_fields = useSelector((state) => state.entities.model_BOM_BOMExactMatch.selected_fields)

    const pricing = bomPricingList;
    const orderBlock = System.getOrderBlockCreditRiskFlagBySpeedboat().isOrderBlock;
    const avUserInfo = liveAuth.getAvUserInfo()
    const getCPN = (v) => {
        // return (v.cpnTypeName === Constants.cpnTypes.MANUALCPN ? v.manualCPN : (v?.customerPartNumber ? v.customerPartNumber.toUpperCase() : v.customerPartNumber))
        return v.cpnTypeName === Constants.cpnTypes.MANUALCPN ? Helper.toUpperCase(v.manualCPN) : Helper.toUpperCase(v?.customerPartNumber)
    }
    const [farnellToggleButton, setFarnellToggleButton] = useReduxState(false, 'farnellToggleButton')


    const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber)
    };

    const getPricing = (ERPMFRPartNumber, ERPPartNumber, customerPartNumber, cpnType,ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber; 
        customerPartNumber = cpnType === Constants.cpnTypes.MANUALCPN && !customerPartNumber ? '*' : customerPartNumber
        if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber + '-' + customerPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber + '-' + customerPartNumber];
        } else if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };

    useEffect(() => {
        async function f() {
            if (Object.entries(selected_fields).length > 0) {
                let cartCount = 0
                let quoteCount = 0
                let cartFirstIn = false
                let quoteFirstIn = false
                let dupCartObj = {};
                let dupQuoteObj = {};
                let getMinPriceBySpeedBoat = await new BOMRepository().getMinPriceBySpeedBoat();
                Object.entries(selected_fields).map(async (v) => {
                    if (bom_detail_by_bom_id_type.Exact.records.hasOwnProperty(v[1].bomDetailId)) {
                        let cartValid = bom_detail_by_bom_id_type.Exact.records[v[1].bomDetailId].isCartValid;
                        let bomDetailData = bom_detail_by_bom_id_type.Exact.records[v[1].bomDetailId]
                        let quoteValid = bom_detail_by_bom_id_type.Exact.records[v[1].bomDetailId].isQuoteValid;

                        let validCartResult = await new BOMRepository().cartValid(v[1], getPricing(v[1].product.ERPMFRPartNumber, v[1].ERPPartNumber, getCPN(v[1]), v[1].cpnTypeName, v[1].ERPPartNumberModified), getInventory(v[1].product.ERPPartNumber))
                        let validQuoteResult = await new BOMRepository().quoteValid(bomDetailData, getMinPriceBySpeedBoat);
                        /**
                         * Owner : Devanshi/Rakshit
                         * Date  : 25/09/2022
                         * Note  : We are overwriting this for now.
                         */
                        if (validCartResult.isCartValid === false &&
                            bomDetailData.product !== undefined &&
                            bomDetailData.quantity > 0 &&
                            bomDetailData.quantity % bomDetailData.product.QtyMult === 0) {
                            validCartResult.isCartValid = true;
                        }

                        if (bomDetailData !== null && bomDetailData.isDeleted !== undefined &&
                            bomDetailData.isDeleted !== null && bomDetailData.isDeleted === false) {
                            if (validate(v[1]).validatePartNumberForCart()) {
                                // Add incase of unique only.
                                if (validate(v[1]).getDisplayStatusForAddToCart() &&
                                    dupCartObj[v[1].ERPPartNumber] === undefined) {
                                    dupCartObj[v[1].ERPPartNumber] = {};
                                    cartFirstIn = true
                                    setValidCartCount(cartCount += 1)
                                }
                            }

                            /**
                             * return always true as per new logic check quote RFQ validation after add to quote in popup in future remaining do count based on validation
                             * Auther: Devanshi patel
                             */
                            if (validQuoteResult.isQuoteValid === true) {
                                if (dupQuoteObj[v[1].ERPPartNumber] === undefined) {
                                    dupQuoteObj[v[1].ERPPartNumber] = {};
                                    quoteFirstIn = true
                                    setValidQuoteCount(quoteCount += 1)
                                } else {
                                    setValidQuoteCount(quoteCount += 1)
                                }
                            }
                        }

                        if (!cartFirstIn) {
                            setValidCartCount(0)
                        }

                        if (!quoteFirstIn) {
                            setValidQuoteCount(0)
                        }
                    }
                })
            } else {
                setValidCartCount(0)
                setValidQuoteCount(0)
            }
        }

        f()
    }, [selected_fields]);

    const validate = (bomDetail) => {
        return new BomExactMatchValidation(bomDetail, getPricing(bomDetail.product.ERPMFRPartNumber, bomDetail.product.ERPPartNumber, getCPN(bomDetail), bomDetail.cpnTypeName, bomDetail.product.ERPPartNumberModified), getInventory(bomDetail.product.ERPPartNumber), CART_BEFORE_TO_SEND_SERVER);
    }

    useEffect(() => {
        async function fetchHere() {
            if (bomMultipleMatchTrigger !== undefined &&
                bomMultipleMatchTrigger !== null &&
                bomMultipleMatchTrigger !== '' &&
                bomMultipleMatchTrigger === 'BOM_EXACT_TRIGGER') {
                let BOMTabResp = await getBOMRedirectionTab(bom_detail_by_bom_id_type);
                if (BOMTabResp !== undefined) {
                    await switchTab(BOMTabResp.tabUrl, BOMTabResp.component, true);
                }
            }
            setFirstServerCall(false)
        }

        fetchHere()
    }, [bom_detail_by_bom_id_type])

    const getBOMRedirectionTab = async (bomDetail) => {
        if (bomDetail !== undefined &&
            bomDetail !== null &&
            bomDetail.Multiple !== undefined &&
            bomDetail.Multiple.matchType !== undefined &&
            bomDetail.Multiple.matchType === Common.chain_BomTabList.BomMultipleMatchTable.api_fetch_type &&
            ((bomDetail.Multiple.records !== undefined
                && Array.isArray(Object.entries(bomDetail.Multiple.records))
                && Object.entries(bomDetail.Multiple.records).length > 0 &&
                Object.entries(bomDetail.Multiple.records).every(x => x[1].isDeleted)
                && Object.entries(bomDetail.Multiple.records).filter(x => x[1].isDeleted === true).length === Object.entries(bomDetail.Multiple.records).length
            ) || (bomDetail.Multiple.records === undefined ||
                Object.entries(bomDetail.Multiple.records).length === 0))) {
            return {
                component: Common.chain_BomTabList.BomExactMatchTable,
                tabUrl: getTabLink(Common.chain_BomTabList.BomExactMatchTable)
            }
        }
    }

    useEffect(() => {
        async function f() {
            await autoBOMRedirection(bom_id); // BOM Redirection based on Count 
        }

        f()
    }, []);

    async function autoBOMRedirection(bom_id) {
        let resp = await get_bom_detail_count_by_bom_id({ bomId: bom_id });
        if (resp !== null && resp.payload !== null && resp.payload !== undefined) {
            if (resp.payload.Exact !== undefined && resp.payload.Exact !== null && resp.payload.Exact.count > 0) {
                return switchTab(getTabLink(Common.chain_BomTabList.BomExactMatchTable), Common.chain_BomTabList.BomExactMatchTable);
            } else if (resp.payload.Multiple !== undefined && resp.payload.Multiple !== null && resp.payload.Multiple.count > 0) {
                return switchTab(getTabLink(Common.chain_BomTabList.BomMultipleMatchTable), Common.chain_BomTabList.BomMultipleMatchTable);
            } else if (resp.payload.NoMatch !== undefined && resp.payload.NoMatch !== null && resp.payload.NoMatch.count > 0) {
                return switchTab(getTabLink(Common.chain_BomTabList.BomNoMatchTable), Common.chain_BomTabList.BomNoMatchTable);
            }
        }
    }

    const getActiveClass = (singleElement) => {
        if (Common.chain_BomTabList[BomTabList__Component__Loader].param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };
    const getTabLink = (singleElement) => {
        return Bom.getBomTabsListRouteURL({
            [Common.param_key_BomTabList]: singleElement.param_value
        });
    };
    const switchTab = async (url, chain_single, isBOMExactRedirect = false) => { 
        
        SetTop({
            NoMatch: { top: 20 },
            Multiple: { top: 20 },
            Exact: { top: 20 }
        })
        if (isBOMExactRedirect && bomMultipleMatchTrigger !== '') {
            store.dispatch(SET_bomMultipleMatchTrigger({
                BOMTriggerVal: '' // reset value 
            }));
        }
        let getNewDataFlag = true;
        if (bom_detail_by_bom_id_type[chain_single.api_fetch_type] !== undefined && bom_detail_by_bom_id_type[chain_single.api_fetch_type].records !== undefined &&
            isObject(bom_detail_by_bom_id_type[chain_single.api_fetch_type].records) &&
            Object.entries(bom_detail_by_bom_id_type[chain_single.api_fetch_type].records).length > 0
        ) {
            getNewDataFlag = false;
        }
        if (getNewDataFlag === true) {
            let top_here = 10;
            if (top[chain_single.api_fetch_type] !== undefined &&
                top[chain_single.api_fetch_type].top
            ) {
                top_here = top[chain_single.api_fetch_type].top;
            }
            top_here = top_here === 10 ? 20 : top_here;
            await get_bom_detail_by_bom_id_with_type({
                bomId: bom_id,
                matchType: chain_single.api_fetch_type,
                isReRunPartMatch: false,
                top: top_here
            });
        }

        history.pushState('', '', url);
        Set_BomTabList__Component__Loader(chain_single.param_value);
        setInitialLoader(false);
        if (!monitorFunctionCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    };

    const getDisplayStatus = (chain_BomTabList_single) => {
        return true;
    };

    const AddBulkQuote = async () => {
        if (_check_p('BOM_ADD_TO_CART').status === false || orderBlock) {
            openContactUsPopup();
            return false;
        }
        if (Object.entries(selected_fields).length > 0) {
            if (selected_fields !== undefined && Object.keys(selected_fields).length > 0) {

                {/***
                 * CR #      : 9654
                 * Change #  : Filter out Obsolete part data that will never submit
                 * Change by : Pankaj 
                */}
                let filtered_selected_fields = produceClone(selected_fields);
                Object.entries(selected_fields).forEach((x) => {
                    if (x[1] && x[1].product && x[1].product && x[1].product.ObsoleteFlag == true) {
                        delete filtered_selected_fields[x[0]];
                    }
                });
                store.dispatch(system_notification({
                    name: 'ValidateRFQQuoteRequest',
                    data: {
                        quoteFrom: 'BOMQuote',
                        quoteList: Object.keys(filtered_selected_fields).length > 0 ? { ...filtered_selected_fields } : { ...selected_fields }
                    },
                }));
                /**
                 * Set Events and Evars as per basav comment (14664)
                 * Author: Devanshi Patel
                 */

                let erpMFRList = Object.entries(filtered_selected_fields).map((data) => {
                    return data[1]?.product?.ERPMFRPartNumber
                }).join(", ")

                if (window?.digitalData) {
                    if (!window?.digitalData?.transaction) {
                        window.digitalData.transaction = {}
                    }
                    window.digitalData.event.eventinfo.events = "Add to Quote clicked from BOM";
                    window.digitalData.transaction.bomSource = "BOM";
                    window.digitalData.transaction.items = erpMFRList
                }
            }
        }
    }
    const onFarnellCheckout = () => {
        if (window?.digitalData) {
            window.digitalData.event.eventinfo.events = "Farnell Checkout clicked";
        }
        //code added by Ramya
        let linkDetails = {
            linkName: "Click here to checkout",
            linkUrl: window.location.href,
            linkLocation: window.document.title,
            linkType:"Button",
            linkComponent:"BOM Page",
        }
        localStorage.setItem("adobeEventType","CTAClickEvent");
        HelperAdobeEvent.trackingAdobeEvent({
           linkDetails
        })
    }

    const getCPNFromContractId = (ItemNumber) => {
        let res = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber] && CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber].CUSTOMER_PART_NUMBER

        return res
    }

    const AddToCart = async () => {
        let filteredPartNumber = {};
        if (_check_p('BOM_ADD_TO_CART').status === false) {
            openContactUsPopup();
            return false;
        }
        if (Object.entries(selected_fields).length > 0) {
            await Promise.all(Object.entries(selected_fields).map(async (v) => {
                if (bom_detail_by_bom_id_type.Exact.records.hasOwnProperty(v[1].bomDetailId)) {
                    let cartValid = bom_detail_by_bom_id_type.Exact.records[v[1].bomDetailId].isCartValid;
                    let bomDetailData = bom_detail_by_bom_id_type.Exact.records[v[1].bomDetailId]
                    let validCartResult = validate(v[1]).validatePartNumberForCart();
                    let isValidCart = validate(v[1]).getDisplayStatusForAddToCart();
                    // Prepare Valid Part Number 
                    if (validCartResult === true && isValidCart === true &&
                        v[1].isDeleted !== undefined &&
                        v[1].isDeleted !== null &&
                        v[1].isDeleted === false) {
                        filteredPartNumber[v[0]] = v[1];
                    }
                }
            }));
        }

        let filteredParts = Object.keys(filteredPartNumber).length > 0 ? filteredPartNumber : selected_fields;

        let items = []
        if (filteredParts && Object.entries(filteredParts).length > 0) {

            Object.entries(filteredParts).map((res, i) => {
                if (res[1].customerPartNumber !== undefined && res[1].product && res[1].product.ItemNumber) {
                    let Obj = {}
                    /**
                     * getCPNFromContractId function is used for get cpn selected when display selected but not set with data
                     * Author: Devanshi Patel
                     */
                    // Obj.cpn = res[1].customerPartNumber ? res[1].customerPartNumber : getCPNFromContractId(res[1].product.ItemNumber) ? getCPNFromContractId(res[1].product.ItemNumber) : ""

                    Obj.itemNumber = res[1].product.ItemNumber
                    Obj.cpnType = res[1].cpnTypeName
                    Obj.cpn = res[1].cpnTypeName === Constants.cpnTypes.CPN ? res[1].customerPartNumber ? res[1].customerPartNumber : getCPNFromContractId(res[1].product.ItemNumber) ? getCPNFromContractId(res[1].product.ItemNumber) : "" : ""
                    Obj.manualCPN = res[1].cpnTypeName === Constants.cpnTypes.MANUALCPN && res[1].manualCPN ? res[1].manualCPN : ''
                    Obj.vendorCode = res[1].product?.VendorCode
                    Obj.sapMatGroup = res[1].product?.SAPMatgroup
                    items.push(Obj)
                }
            })
        }
        let checkItemParam = {
            items: items,
            type: "Shopping"
        }

        let checkExistingItemResponse = await check_item_exists_in_cart(checkItemParam);

        if (checkExistingItemResponse === true) {
            System.popup('BomToCartItemReplacePopup', {
                cartReplaceItem: { ...filteredParts }
            })
        } else {
            let selectedProductData = await add_cart_in_Bulk({ ...filteredParts });
            let prodDetails = [];
            if(filteredParts){
                Object.entries(filteredParts).map((data, i) => {
                  prodDetails.push(data[1].product);
                });
              }
            store.dispatch(system_notification({
                name: 'AddedToCartBomPopup',
                data: {
                    cartData: selectedProductData.payload,
                    isCartBOM: true,
                    prodDetails : prodDetails // added by Ramya
                },
            }));
            __set('CART_API_CALL');
            await initiatedKernelCall({ minicart: true })
            __remove('CART_API_CALL');

            let erpMFRList = selectedProductData.payload.map((data) => {
                return data.erpMfrPartNumber
            }).join(", ")

            /**
             * Set Events and Evars as per basav comment (14664)
             * Author: Devanshi Patel
             */

            if (window?.digitalData) {
                if (!window?.digitalData?.transaction) {
                    window.digitalData.transaction = {}
                }
                window.digitalData.event.eventinfo.events = "ATC clicked from BOM";
                window.digitalData.transaction.bomSource = "BOM";
                window.digitalData.transaction.items = erpMFRList
            }

            // store.dispatch(event({
            //     event_name: 'CartInitiated',
            //     event_data: {
            //         called_from_add_to_cart: true
            //     },
            // }));
        }

    }

    const openContactUsPopup = () => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: { restrict: true, order_block: orderBlock },
        }));
    };

    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status === true &&
            _check_p('PDG_ADD_TO_BOM').status === true &&
            _check_p('PDG_CLICK_TO_QUOTE').status === true ? true : false);
    }

    const validateNonLoginUser = () => {
        if (!liveAuth.check()) {
            return true;
        }
        if (liveAuth.check() && isGuestFullRights() === false) {
            return true;
        }
        return false;
    }

    useEffect(() => {
        const handleScroll = () => {
        //   const tableHeader =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
          const tableHeader = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight - 1 : 65 + 1
          if (tableHeader) {
            setHeaderDistance(tableHeader);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

    const getContactUsButton = () => {
        return (
            <button onClick={() => {
                openContactUsPopup()
            }}
                className='bs5 btn btn-primary click-to-quote-btn'
            >Contact Us
            </button>
        )
    };
    useEffect(() => {
        const handleScroll = () => {
            //   const tableHeader =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            let tableHeader = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight - 1 : 65 + 1
            if (tableHeader) {
                const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;
                if (adminToolBarHeight > 0) {
                    tableHeader = tableHeader + adminToolBarHeight;
                }

                setHeaderDistance(tableHeader);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const OnfarnellChackout = () => {
        const div = document.getElementById('BOMStickyHeader')
        div.style.zIndex = 99
        
        System.popup('RegisterDesignPopup', {})
    }

    return (
        <>
            {/**
             * CR 12327 display conditionally based on isExternalBom flag
             * Author: Devanshi Patel
             */}
            {
                bom_detail_by_bom_id_type && bom_detail_by_bom_id_type.isExternalBom && !farnellToggleButton &&
                <div className='container-fluid primary-bg-color order-prototype' id="BOMStickyHeader" style={{ position: 'sticky', top: headerDistance, zIndex: '999' }}>
                    <div className="mb-3 mb-md-0 container order-prototype-container text-center position-relative">
                        <div className='d-block d-lg-flex align-items-center justify-content-md-start justify-content-lg-center'>
                            <span className='order-prototype-icon me-2'></span>
                            Need Smaller Quantities? Order Prototype Quantities for below parts at Farnell
                            <a href={void (0)} onClick={() => {setCheckoutFarnellClick(true); onFarnellCheckout()}} className="bs5 btn btn-primary-outline ms-3"> Click here to checkout </a>
                        </div>
                        <span className='newark-logo'></span>
                    </div>
                </div>
            }

            <div className="container">
                <BomTabsData />

                {farnellToggleButton ?<BomfarnellList bomDetail={bom_detail_by_bom_id_type} bomInfo={bom_detail_by_bom_id} /> : <div className="mb-5">
                    <div className="tabs-text-top align-self-center d-block d-lg-none mt-3">
                        <button className="bs5 btn btn-secondary me-3 w180 mb-3 mb-md-0">add item(s) to quote</button>
                        <button className="bs5 btn btn-primary w170 mb-3 mb-md-0">add item(s) to <i
                            className="fa fa-cart-plus ms-1" /></button>
                    </div>
                    <div className='d-flex justify-content-between align-items-end bb4'>
                        <div className="mobile-tab bom-tab">
                            <ul className="bs5 nav nav-tabs border-bottom-0">
                                {Object.entries(Common.chain_BomTabList).map((v) => (
                                    <React.Fragment key={v[1].name}>
                                        {getDisplayStatus(v[1]) &&
                                            <li key={v[1].name} className="maxw-auto">
                                                <a className={'w-auto text-uppercase font-bold ' + getActiveClass(v[1])}
                                                    href={void (0)}
                                                    onClick={async () => {
                                                        await switchTab(getTabLink(v[1]), v[1])
                                                    }}
                                                >{v[1].icon}
                                                    <span>
                                                        {v[1].name}
                                                        {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status === false &&
                                                            <>
                                                                <span>  </span> {v[1].store().count}/{bom_detail_by_bom_id_type.totalMatches}
                                                            </>
                                                        }
                                                    </span>
                                                </a>
                                            </li>
                                        }
                                    </React.Fragment>
                                ))
                                }
                            </ul>
                        </div>

                        {(!Helper.validateDomain(avUserInfo?.email) && bom_detail_by_bom_id_type?.isExternalBom) && (
                            <div className="tabs-text-top align-self-center  d-block drms-registration">
                                <span> DRMS Registration</span>
                                <button className="bs5 btn btn-primary minw-auto" onClick={() => OnfarnellChackout()}>Register Now</button>
                            </div>
                        )}
                        {isObject(selected_fields) &&
                            <div className="tabs-text-top align-self-center d-none d-lg-block">
                                <>
                                    <button
                                        className={(validQuoteCount < 1) ? 'bs5 btn btn-secondary me-3 w180 mb-3 mb-md-0 disabled' : 'bs5 btn btn-secondary me-3 w180 mb-3 mb-md-0'}
                                        disabled={validQuoteCount < 1 || validateNonLoginUser()}
                                        onClick={() => AddBulkQuote()}>add item({validQuoteCount}) to
                                        quote
                                    </button>

                                    {/**
                                     * Story #  : 11694 
                                     * Change # : Validate Order Block flag and show contact us
                                     * Change by : PN
                                     * Date      : 20 Dec,2023
                                     */
                                    }
                                    {orderBlock ? getContactUsButton() :
                                        <>
                                            <button className="bs5 btn btn-primary w170 mb-3 mb-md-0"
                                                onClick={(e) => {
                                                    __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? e.preventDefault() : AddToCart()
                                                }} disabled={validCartCount < 1 || validateNonLoginUser()}
                                            >
                                                {__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status &&
                                                    <>
                                                        add item({validCartCount}) to <i className="fa fa-spinner fa-spin" />
                                                    </>
                                                }
                                                {!__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status &&
                                                    <>
                                                        add item({validCartCount}) to
                                                        <i className="fa fa-cart-plus ms-1" />
                                                    </>
                                                }
                                            </button>
                                        </>
                                    }
                                </>
                            </div>
                        }
                    </div>
                    <div
                        id={Common.chain_BomTabList[BomTabList__Component__Loader].param_value}
                        className="tab-pane active table-container">
                        {React.createElement(Common.chain_BomTabList[BomTabList__Component__Loader].element, {
                            current_chain: Common.chain_BomTabList[BomTabList__Component__Loader]
                        })}
                    </div>
                </div>}
            </div>

        </>
    );
}

export default BomTabs;